export const geoApiOptions = {
  method: 'GET',
  headers: {
		'X-RapidAPI-Key': 'ebb092e631msh410be3a68885310p10e7bdjsn09d41238ed0b',
		'X-RapidAPI-Host': 'wft-geo-db.p.rapidapi.com'
	}
};

export const GEO_API_URL = "https://wft-geo-db.p.rapidapi.com/v1/geo";

export const WEATHER_API_URL = "https://api.openweathermap.org/data/2.5";

export const WEATHER_API_KEY = "da08f070efd48e0c137af82ade4c965c";